export default __webpack_public_path__ + "static/media/FiraSans-Regular.e6634e9a.woff2";